import * as React from 'react';
import { scaleOrdinal } from 'd3';
// custom
import { Canvas } from '../components/Canvas';
import { colorPalette, defaultMargins } from '../utils';
// local
import { MiniBarGroup } from './components/MiniBarGroup';
import { generateScalesMap } from './utils';
import { useCharts } from '../components/Charts';
import { getCoordValues } from '../TrackArea/utils';
// 🍺 🍷 🧃
export function MiniBar(_a) {
    var series = _a.series, accessors = _a.accessors, name = _a.name, margins = _a.margins, meta = _a.meta, yMin = _a.yMin, yMax = _a.yMax, _b = _a.barHeight, barHeight = _b === void 0 ? 32 : _b, _c = _a.spaceBetween, spaceBetween = _c === void 0 ? 8 : _c, tooltip = _a.tooltip, _d = _a.colors, colors = _d === void 0 ? colorPalette : _d;
    var _e = useCharts(), width = _e.width, pointXY = _e.pointXY, setPinned = _e.setPinned;
    var parsedMargins = defaultMargins(margins);
    var seriesList = React.useMemo(function () { return Object.values(series); }, [series]);
    var colorScheme = React.useMemo(function () {
        return scaleOrdinal()
            .domain(Object.values(series).map(function (d) { return accessors.key(d); }))
            .range(colors);
    }, [series, colors]);
    var count = React.useMemo(function () { return Object.keys(series).length; }, [series]);
    var labelHeight = accessors.group !== undefined ? 40 : 24;
    var rowHeight = barHeight + labelHeight + spaceBetween;
    var scalesMap = React.useMemo(function () {
        return generateScalesMap({
            series: series,
            accessors: accessors,
            xMax: width - parsedMargins.left - parsedMargins.right,
            barHeight: barHeight,
            yMin: yMin,
            yMax: yMax
        });
    }, [series, accessors, width, barHeight, yMin, yMax]);
    // NOTE: we're setting the `pinned` state here so that the
    // entire series is treated as one, rather than each 'group'
    // being treated as an entirely separate chart.
    React.useEffect(function () {
        if (pointXY !== undefined && name !== undefined) {
            var vals = seriesList.map(function (s) {
                var val = getCoordValues({
                    series: [s],
                    accessors: accessors,
                    xScale: scalesMap[accessors.key(s)].xScale,
                    mouseX: pointXY.x,
                    mouseY: pointXY.y,
                    colorScheme: colorScheme
                });
                return val;
            });
            var grouped = vals.reduce(function (g, v) {
                if (g === undefined) {
                    return v;
                }
                if ((v === null || v === void 0 ? void 0 : v.data[0]) !== undefined) {
                    g.data.push(v.data[0]);
                }
                return g;
            }, undefined);
            setPinned(name, grouped);
        }
    }, [pointXY]);
    return (React.createElement("div", { style: { position: 'relative' } },
        React.createElement(Canvas, { height: count * rowHeight + parsedMargins.top + parsedMargins.bottom, margins: parsedMargins },
            React.createElement(MiniBarGroup, { barHeight: barHeight, rowHeight: rowHeight, series: series, accessors: accessors, meta: meta, colorScheme: colorScheme, tooltip: tooltip, scalesMap: scalesMap }))));
}
//# sourceMappingURL=MiniBar.js.map